import styled, { CSSProperties } from "styled-components";

export const HelperTextWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacings.xs5};
  margin-top: ${({ theme }) => theme.spacings.xs5};
  margin-left: ${({ theme }) => theme.spacings.xs2};
`;

export const PopoverContentWrapper = styled.div<{ zIndex: number }>`
  width: var(--radix-popover-trigger-width);
  box-shadow: 0px 4px 28px 0px rgba(0, 0, 0, 0.1);
  max-height: min(var(--radix-popover-content-available-height), 400px);
  padding: ${({ theme }) => theme.spacings.xs3};
  background-color: ${({ theme }) => theme.colors.neutral[100]};
  border-radius: ${({ theme }) => theme.borders.radius.xs};
  overflow: hidden;
  z-index: ${({ zIndex }) => zIndex + 1000};

  display: flex;
  flex-direction: column;
`;

export const OptionsWrapper = styled.div`
  margin-top: ${({ theme }) => theme.spacings.xs2};
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacings.xs5};
`;

export const SelectedOptionsWrapper = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacings.xs5};
  flex-wrap: nowrap;
  overflow: hidden;
  min-width: 0;
  width: 100%;
`;

export const LabelWithSelectedOptionsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex: 1;
  min-width: 0;
`;

export const localStyles = {
  selectedOptionLabel: {
    display: "inline-block",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    maxWidth: "100%",
    minWidth: "0",
    flexShrink: 0,
    WebkitTextFillColor: "rgba(0, 0, 0, 0.38)",
  },
  selectedOptionsTag: {
    display: "inline-block",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    maxWidth: "250px",
    minWidth: "0",
    flexShrink: 0,
  },
  plusOptionTag(isVisible: boolean) {
    return {
      flexShrink: 0,
      visibility: (isVisible
        ? "visible"
        : "hidden") as CSSProperties["visibility"],
    };
  },
};
